// extracted by mini-css-extract-plugin
export default {"root":"_3ry2F","color-green":"_4rSs0","colorGreen":"_4rSs0","color-red":"MnSVR","colorRed":"MnSVR"};